import React, { ReactNode } from "react";
import { motion } from "framer-motion";

interface ScrollingBannerProps {
  items: string[] | ReactNode[];
  speed?: number;
  title?: string;
}

const ScrollingBanner: React.FC<ScrollingBannerProps> = ({
  items,
  speed = 25,
  title = "UC Waves News",
}) => {
  const repeatedItems = [...items, ...items, ...items, ...items];

  return (
    <div className="relative w-full overflow-hidden bg-blue-900 text-white py-4 border-y border-white/10">
      {/* Left and right fade gradients */}
      <div className="absolute left-0 top-0 h-full w-12 bg-gradient-to-r from-blue-900 to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 h-full w-12 bg-gradient-to-l from-blue-900 to-transparent z-10 pointer-events-none" />

      <div className="flex flex-col sm:flex-row items-center sm:gap-6 px-4 sm:px-6">
        {/* Title section */}
        <div className="flex items-center gap-4 mb-2 sm:mb-0">
          <span className="text-base text-red-600  sm:text-lg md:text-2xl font-bolder whitespace-nowrap">
            {title}
          </span>
          <div className="h-8 w-px bg-gradient-to-b from-transparent via-white/50 to-transparent hidden sm:block" />
        </div>

        {/* Mobile horizontal divider */}
        <div className="w-full h-px bg-white/20 my-2 sm:hidden" />

        {/* Scrolling content */}
        <div
          className="relative w-full overflow-hidden"
          style={{ height: "4.5rem" }}
        >
          <motion.div
            className="absolute flex items-center gap-6 whitespace-nowrap"
            initial={{ x: 0 }}
            animate={{ x: "-50%" }}
            transition={{
              duration: speed,
              repeat: Infinity,
              ease: "linear",
            }}
          >
            {repeatedItems.map((item, i) => (
              <div
                key={i}
                className="flex items-center justify-center h-full px-4"
              >
                {typeof item === "string" ? (
                  <span className="text-sm sm:text-base font-medium">
                    {item}
                  </span>
                ) : (
                  <div className="flex items-center gap-3">{item}</div>
                )}
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ScrollingBanner;
